import { SchoolService, BaseService } from "@/services/school.service";

const WellbeingService = {

    getWorkoutAreaSurveys() {
        return SchoolService.getAll("wellbeing/surveys/area?area=workout&include=questions")
    },

    // UNIT BASED

    getSurveysForUnit(courseId) {
        return SchoolService.getAll("courses/" + courseId + "/surveys")
    },

    getSurveyQuestions(object) {
        return SchoolService.getAll("wellbeing/surveys/" + object.identifier + "/questions?include=answers")
    },

    // Replies
    getWorkoutSurveyReplies(workoutId, object) {
        return SchoolService.getAll("health/workouts/" + workoutId + "/surveys/" + object.identifier + "/replies")
    },

    getPupilUnitSurveyReplies(pupil, courseId, object) {
        return SchoolService.getAll("pupils/"  + pupil.identifier + "/courses/" + courseId + "/surveys/" + object.identifier + "/replies")
    },

    // crud
    addReply(payload) {
        return SchoolService.create("wellbeing/surveys/replies", payload)
    },

    updateReply(object) {
        return SchoolService.update("wellbeing/surveys/replies", object.identifier, object)
    },

}

export { WellbeingService };